import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store'

const News = () => import('./Web/EyeCenter/News')
const DeskPhoneInfo = () => import('./DeskPhoneInfo/DeskPhoneInfo')
const DashBoard = () => import('./DashBoard/DashBoard')
const Login = () => import('./Login/Login')
const Home = () => import('./Home/Home')
const App = () => import('./App.vue')

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: App,
            name: 'App',
            props: true,
            redirect:"Home",
            children: [
                {
                    path: 'Home',
                    component: Home,
                    name: 'Home',
                    requiresAuth: true
                },
                {
                    path: 'DeskPhoneInfo/:ServicePhone',
                    component: DeskPhoneInfo,
                    name: 'DeskPhoneInfo',
                    props: true,
                    requiresAuth: true
                },
                {
                    path: 'DashBoard/:ServicePhone',
                    component: DashBoard,
                    name: 'DashBoard',
                    props: true,
                    requiresAuth: true
                },
                {
                    path: 'Eyecenter/News',
                    component: News,
                    name: 'News',
                    props: true,
                    requiresAuth: true
                },
            ],
            beforeEnter(to, from, next) {
                let LoginStatus = localStorage.getItem("LoginStatus")
                if (to.name !== 'Login' && !LoginStatus) next({ name: 'Login' })
                else next()
            }
        },
        {
            path: '/Login',
            component: Login,
            name: 'Login',
            beforeEnter(to, from, next) {
                let LoginStatus = localStorage.getItem("LoginStatus")
                if (to.name == 'Login' && LoginStatus) next({ name: 'Home' })
                else next()
            }
        }
    ],
})

